const initialState = {
  IndikatorList: [],
  IndikatorDetail: null,
  FormulaVariables: { variabel: [], fungsi: [] },
  BaselineList: [],
  FactorList: [],
  EquivalenceList: [],
  DashboardData: null,
  TrenData: null,
  EfisiensiData: null,
  KualitasData: null,
  BreakdownData: null,
  ImpactPeriode: null,
  HrPeriod: null,
};

const sustainabilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INDIKATOR_LIST":
      return { ...state, IndikatorList: action.payload || [] };
    case "INDIKATOR_DETAIL":
      return { ...state, IndikatorDetail: action.payload };
    case "FORMULA_VARIABLES":
      return {
        ...state,
        FormulaVariables: action.payload || { variabel: [], fungsi: [] },
      };
    case "BASELINE_LIST":
      return { ...state, BaselineList: action.payload || [] };
    case "FACTOR_LIST":
      return { ...state, FactorList: action.payload || [] };
    case "EQUIVALENCE_LIST":
      return { ...state, EquivalenceList: action.payload || [] };
    case "SUSTAIN_DASHBOARD":
      return { ...state, DashboardData: action.payload };
    case "SUSTAIN_TREN":
      return { ...state, TrenData: action.payload };
    case "SUSTAIN_EFISIENSI":
      return { ...state, EfisiensiData: action.payload };
    case "SUSTAIN_KUALITAS":
      return { ...state, KualitasData: action.payload };
    case "SUSTAIN_BREAKDOWN":
      return { ...state, BreakdownData: action.payload };
    case "SUSTAIN_IMPACT_PERIODE":
      return { ...state, ImpactPeriode: action.payload };
    case "SUSTAIN_HR_PERIOD":
      return { ...state, HrPeriod: action.payload };
    default:
      return state;
  }
};

export default sustainabilityReducer;
